/* ==========================================================================
   ABEERS Wholesale — Enquiry form UX layer
   The form itself posts natively to Shopify's /contact endpoint (no fetch/
   AJAX email sending, no exposed address). This script only adds:
   - inline validation before allowing submit
   - a honeypot + time-trap spam check (blocks obvious bots client-side;
     Shopify's own spam filtering still applies server-side)
   - a disabled/loading state on the submit button while the page posts
   ========================================================================== */
(function () {
  'use strict';

  function initForm(form) {
    var submitBtn = form.querySelector('.aw-submit');
    var timestampField = form.querySelector('[data-aw-timestamp]');
    var honeypot = form.querySelector('input[name="aw_website"]');

    if (timestampField) timestampField.value = Date.now().toString();

    var validators = {
      email: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); },
      phone: function (v) { return /^[+]?[\d\s()-]{7,15}$/.test(v); }
    };

    function setError(fieldEl, hasError) {
      fieldEl.classList.toggle('has-error', hasError);
    }

    function validateField(fieldEl) {
      var input = fieldEl.querySelector('input, select, textarea');
      if (!input || !input.hasAttribute('required')) return true;
      var value = (input.value || '').trim();
      var valid = value.length > 0;

      if (valid && input.type === 'email') valid = validators.email(value);
      if (valid && input.type === 'tel') valid = validators.phone(value);

      setError(fieldEl, !valid);
      return valid;
    }

    form.querySelectorAll('[data-aw-field]').forEach(function (fieldEl) {
      var input = fieldEl.querySelector('input, select, textarea');
      if (!input) return;
      input.addEventListener('blur', function () { validateField(fieldEl); });
      input.addEventListener('input', function () {
        if (fieldEl.classList.contains('has-error')) validateField(fieldEl);
      });
    });

    form.addEventListener('submit', function (e) {
      var allValid = true;
      form.querySelectorAll('[data-aw-field]').forEach(function (fieldEl) {
        if (!validateField(fieldEl)) allValid = false;
      });

      // Honeypot: any value here means a bot filled every field.
      var honeypotFilled = honeypot && honeypot.value.trim() !== '';

      // Time-trap: legitimate humans take at least ~2.5s to fill a form
      // this detailed; near-instant submits are almost always automated.
      var renderedAt = parseInt((timestampField && timestampField.value) || '0', 10);
      var tooFast = renderedAt && (Date.now() - renderedAt) < 2500;

      if (!allValid || honeypotFilled || tooFast) {
        e.preventDefault();
        if (!allValid) {
          var firstError = form.querySelector('.has-error');
          if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      submitBtn.classList.add('is-loading');
      submitBtn.disabled = true;
      // Native form submit proceeds; Shopify handles delivery + redirect.
    });
  }

  function init() {
    document.querySelectorAll('[data-aw-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
